import {
  URL_CREATE_NEW_JOB,
  URL_LIST_JOBS,
  URL_GLOBAL_JOB_DETAILS_OPEN,
  URL_GLOBAL_JOB_DETAILS_EXPIRED,
  URL_EDIT_DRAFT,
  URL_COPY_JOB,
  URL_REFRESH_JOB,
  URL_CANDIDATES,
  URL_EDIT_JOB,
  URL_ACCOUNT_COMPANY_PROFILE_EDIT,
  URL_UPGRADE_JOB,
  URL_CANDIDATES_RECOMMENDED,
} from '@seek/adv-constants';
import { createAbsoluteUrl } from '@seek/melways-sites';

import type { DashboardJobFragment } from 'src/graphql/generated';

import {
  getCountryFromSite,
  getLanguage,
  getSite,
  isStaging,
  urlResolver,
} from './config';

export const getCandidateManagementUrl = (jobId: string): string =>
  urlResolver({ path: `${URL_CANDIDATES}?jobid=${jobId}` });

export const getPremiumTalentSearchUrl = (path: string): string =>
  urlResolver({
    path,
  });

export const getCreateNewJobUrl = (): string =>
  urlResolver({
    path: URL_CREATE_NEW_JOB,
  });

export const getJobsListUrl = (): string =>
  urlResolver({
    path: URL_LIST_JOBS,
  });

export const getViewJobAdUrl = (
  jobId: string,
  jobStatus: string,
): { href: string; target?: string } => {
  if (jobId && jobStatus) {
    const site = getSite();
    const language = getLanguage();
    const country = getCountryFromSite(site);
    switch (jobStatus) {
      case 'ACTIVE':
        return {
          href: createAbsoluteUrl({
            product: 'candidate',
            country,
            language,
            path: `${URL_GLOBAL_JOB_DETAILS_OPEN}/${jobId}`,
            staging: isStaging(),
          }),
          target: '_blank',
        };

      case 'EXPIRED':
        return {
          href: createAbsoluteUrl({
            product: 'candidate',
            country,
            language,
            path: `${URL_GLOBAL_JOB_DETAILS_EXPIRED}/${jobId}`,
            staging: isStaging(),
          }),
          target: '_blank',
        };
    }
  }
  return { href: '#' };
};

export const getJobAnalyticsUrl = (jobId: string): string =>
  urlResolver({ path: `/analytics/job/${jobId}` });

// Edit draft and copy job params are added here with "&" as the URL consts include a "?referrer=xxx" param
export const getContinueDraftUrl = (draftId: string): string =>
  urlResolver({ path: `${URL_EDIT_DRAFT}&draftId=${draftId}` });

export const getCopyJobUrl = (jobId: string): string =>
  urlResolver({ path: `${URL_COPY_JOB}&jobId=${jobId}` });

// Edit job and refresh job params are added here with "?" as job URL consts don't include any query params
export const getEditJobUrl = (jobId: string): string =>
  urlResolver({ path: `${URL_EDIT_JOB}?jobId=${jobId}` });

export const getRefreshJobUrl = (jobId: string): string =>
  urlResolver({ path: `${URL_REFRESH_JOB}?jobId=${jobId}` });

export const getUpgradeJobUrl = (jobId: string): string =>
  urlResolver({
    path: `${URL_UPGRADE_JOB}/${jobId}?ref=dashboard`,
  });

export const getCompanyProfileEditUrl = (): string =>
  urlResolver({
    path: URL_ACCOUNT_COMPANY_PROFILE_EDIT,
  });

export const getRecommendedCandidatesUrl = (job: DashboardJobFragment) =>
  `${URL_CANDIDATES_RECOMMENDED}?jobId=${job.id}`;

export const getHowToWriteJobAdUrl = (): string =>
  urlResolver({
    path: '/hiring-advice/article/how-to-write-a-great-job-ad-with-examples',
  });
